import styled from 'styled-components';
import GasStationTable from '../../components/table/GasStationTable';

function GasStation() {
  return (
    <Wrapper>
      <GasStationTable />
    </Wrapper>
  );
}

export default GasStation;

const Wrapper = styled.div``;
